import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../redux/imgCate/actions';

class ImgCateThankYou extends Component {
    componentDidMount(){
        if (this.props.imgCate.submitted){
            this.props.submitCompleted();
        }
    }
    render() {
        const { imgCate } = this.props;
        
        return (
            <div className="container">
                <div className="jumbotron centered text-center">
                    <div className='row'>
                        <br />
                    </div>
                    <div className='row'>
                        <div className='col-sm'>
                            <h4>{imgCate.task?imgCate.task.task_name:'Task Title'}</h4>
                        </div>    
                    </div>
                    <div className='row'>
                        <br />
                    </div>
                    <div className='row'>
                        <div className='col-sm'>
                                <blockquote className="blockquote">
                                    <h4 className="display-4">Thank you</h4>
                                    <p className="mb-0">Your task has been submitted successfully.</p>
                                    <footer className="blockquote-footer">Team at <cite title="Source Title">Swarm Colony</cite></footer>
                                </blockquote>
                            
                        </div>    
                    </div>
                </div>  
            </div>    
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        imgCate: state.imgCate
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        submitCompleted: () => {
          dispatch(actions.submitCompleted())  
      }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(ImgCateThankYou);


// WEBPACK FOOTER //
// ./src/views/ImageCategorisation/ImgCateThankYou.js